<template>
  <div
    class="md:col-span-2 lg:col-span-1 trezo-card relative p-[20px] md:p-[25px] rounded-md"
    style="background: linear-gradient(73deg, #23272e 0%, #343a46 100%)"
  >
    <div class="trezo-card-content">
      <span class="block mb-[4px] text-gray-400">
        New customers this month
      </span>
      <h3 class="mb-[20px] text-[20px] text-white">4,712</h3>
      <span class="block text-gray-400 mb-[10px]"> Join Today </span>
      <div class="flex items-center">
        <img
          src="@/assets/images/users/user36.jpg"
          class="rounded-full w-[40px] border border-white ltr:-mr-[10px] rtl:-ml-[10px] ltr:last:mr-0 rtl:last:ml-0"
          alt="user-image"
        />
        <img
          src="@/assets/images/users/user37.jpg"
          class="rounded-full w-[40px] border border-white ltr:-mr-[10px] rtl:-ml-[10px] ltr:last:mr-0 rtl:last:ml-0"
          alt="user-image"
        />
        <img
          src="@/assets/images/users/user38.jpg"
          class="rounded-full w-[40px] border border-white ltr:-mr-[10px] rtl:-ml-[10px] ltr:last:mr-0 rtl:last:ml-0"
          alt="user-image"
        />
        <img
          src="@/assets/images/users/user39.jpg"
          class="rounded-full w-[40px] border border-white ltr:-mr-[10px] rtl:-ml-[10px] ltr:last:mr-0 rtl:last:ml-0"
          alt="user-image"
        />
        <img
          src="@/assets/images/users/user40.jpg"
          class="rounded-full w-[40px] border border-white ltr:-mr-[10px] rtl:-ml-[10px] ltr:last:mr-0 rtl:last:ml-0"
          alt="user-image"
        />
        <div
          class="flex items-center justify-center bg-orange-400 border border-white w-[40px] h-[40px] rounded-full text-white font-semibold ltr:-mr-[10px] rtl:-ml-[10px] ltr:last:mr-0 rtl:last:ml-0"
        >
          59
        </div>
      </div>
    </div>
    <img
      src="@/assets/images/icons/4dot3.svg"
      class="absolute bottom-0 ltr:right-0 rtl:left-0 rtl:-scale-x-100"
      alt="4dot"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "NewCustomers",
});
</script>
